import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_10: FaireProductEntity = {
  token: "viverano-10",
  type: "product",
  name: "Women's Eco-Chic Poncho Sweater Knit Pullover (Organic)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/6486e435d744549ad30b46b15bf2e65442b70d27993385a50d90e047e73ace73.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1070,1071,x0,y75,safe&width=720",
  priceDollars: 42,
  msrpDollars: 72,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-women"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
